import styles from '../index.module.scss'
import { buildComposerMentionKeyDown } from './composerMentionKeyDown.js'

export function buildComposerEditorProps({ editorAriaLabel, mentionOpenRef, mentionFlatCountRef, setMentionActiveIndex, setMentionTrigger, setMentionAnchor }) {
  return {
    attributes: {
      class: `${styles.textarea} ${styles.composerProseMirror}`,
      spellcheck: 'true',
      role: 'textbox',
      'aria-multiline': 'true',
      ...(editorAriaLabel ? { 'aria-label': editorAriaLabel } : {}),
    },
    handlePaste(_view, event) {
      const items = event.clipboardData?.items
      if (items && [...items].some((it) => it.type.startsWith('image/'))) {
        event.preventDefault()
        return true
      }
      return false
    },
    handleDrop(_view, event) {
      if (event.dataTransfer?.files?.length) {
        event.preventDefault()
        return true
      }
      return false
    },
    handleKeyDown: buildComposerMentionKeyDown({ mentionOpenRef, mentionFlatCountRef, setMentionActiveIndex, setMentionTrigger, setMentionAnchor }),
  }
}
